import { Component, OnInit, Input } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContagemInventarioService } from 'src/app/services/contagem-inventario/contagem-inventario.service';
import { ContagemInventarioComponent } from '../contagem-inventario.component';


@Component({
  selector: 'app-itens-inventariados',
  templateUrl: './itens-inventariados.component.html',
  styleUrls: ['./itens-inventariados.component.scss']
})
export class ItensInventariadosComponent implements OnInit {
  public isLoading = false;
  public totalNRT: number = 0;
  public totalVolume: number = 0;
  public paging = { index: 0, size: 10, length: 0 };
  public displayedColumns: string[] = [
    'contador',
    'data',
    'inventariante',
    'NRT',
    'barcode',
    'etiqueta',
    'documento',
    'cliente',
    'status',
  ];

  public colletion: MatTableDataSource<any> = new MatTableDataSource<any>();

  @Input() numero: number;

  constructor(
    public serviceContagemInventario: ContagemInventarioService,
    public snackBar: MatSnackBar,
  )
  {
  }


  ngOnInit() {
    this.searchItens();
  }

  public searchItens(){
    const obj = {
      numero: this.numero,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size,
    }
    this.isLoading = true;
    this.serviceContagemInventario.getAllItensInventariados(obj)
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any[]>) => {
          this.colletion.data = response.body;
          if (response.body.length > 0) {
            this.paging.length = response.body[0].totalCount;
            this.totalNRT = response.body[0].totalNRT;
            this.totalVolume = response.body[0].totalVolume;
          }
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar listagem itens inventariados!', 'OK', 5000, 'danger-snackbar');
        });
  }

  public onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.searchItens();
  }

  public openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
